module.exports = __webpack_public_path__ + "static/scale-model-of-language-of-the-birds-in-berkeley-california-080bf2c9e78aaf683f8067d5bb420f8b.png";